import { inject, Injectable, signal } from "@angular/core";
import { TranslationService } from "./translation/translation.service";

export type ToastType = 'create' | 'update' | 'delete' | 'admin-server-error' | 'user-server-error' | 'error';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private static readonly AUTO_DISMISS_MS = 3500;

  readonly toasts = signal<Toast[]>([]);

  #nextId = 1;
  readonly #translationService = inject(TranslationService);

  // Le `message` est typiquement une clé de translation (ex. 'organization.update.success').
  // Si la clé n'est pas connue, la traduction retombe sur la chaîne brute.
  showNotification(message: string, action: ToastType): void {
    const id = this.#nextId++;
    const translated = this.#translationService.getTranslation(message);
    this.toasts.update(curr => [...curr, { id, message: translated, type: action }]);

    // Auto-dismiss après quelques secondes ; conserve les erreurs un peu plus
    // longtemps pour que l'utilisateur ait le temps de les lire.
    const ttl = action === 'error' || action.endsWith('-server-error')
      ? NotificationService.AUTO_DISMISS_MS + 1500
      : NotificationService.AUTO_DISMISS_MS;
    setTimeout(() => this.dismiss(id), ttl);
  }

  dismiss(id: number): void {
    this.toasts.update(curr => curr.filter(t => t.id !== id));
  }
}
